import { defaultItem, ItemDto } from "src/dtos/item/itemDto";
import {
	defaultTqcInspectItemDto,
	TqcInspectItemDto,
} from "src/dtos/tqcInspectItem/tqcInspectItemDto";

export interface TQC5020_R01HeaderDto extends ItemDto {
	itemGroupNm: string;
}

export interface TQC5020_R01DetailDto extends TqcInspectItemDto {
	inspItemGroup: string;
	inspItemGroupNm: string;
	specValue1: string;
	specRange: string;
	specRangeNm: string;
	specValue2: string;
	inspUnit: string;
	valueType: string;
	valueTypeNm: string;
	inspMethod: string;
	inspMethodNm: string;
}

export const defaultTQC5020_R01HeaderDto: TQC5020_R01HeaderDto = {
	...defaultItem,
	itemGroupNm: '',
};

export const defaultTQC5020_R01DetailDto: TQC5020_R01DetailDto = {
	...defaultTqcInspectItemDto,
	inspItemGroup: '',
	inspItemGroupNm: '',
	inspItemUsage: 'N',
	specValue1: '',
	specRange: '',
	specRangeNm: '',
	specValue2: '',
	inspUnit: '',
	valueType: '',
	valueTypeNm: '',
	inspMethod: '',
	inspMethodNm: '',
};
